module.exports = __webpack_public_path__ + "static/img/white-logo.375311f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/white-logo.svg
// module id = xIyr
// module chunks = 38